export { default as getAppVersion } from "./getAppVersion";
export { openLinkInApp, openLinkNative, openLinkWeb } from "./openLink";
